import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pdf-forms',
  templateUrl: './pdf-forms.component.html',
  styleUrls: ['./pdf-forms.component.css']
})
export class PdfFormsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pdf-forms/pdf-forms.component.ts